export default __webpack_public_path__ + "static/media/3p.d8ed7827.svg";